import Api from "../helpers/api";

export const vratGeojsonData = async (url) => {
  if (!url) {
    return false;
  }
  try {
    const response = await Api.get(`/api/v1/smartmap/${url}`);

    return response.data || false;
  } catch (error) {
    console.error(error);
  }
};
